// Purchase-eligibility guards shared between the checkout UI and its tests.
//
// Books (digital or physical) can only be bought by a signed-in account: the
// purchase is tied to the buyer's in-app library and to the receipt email we
// send both the customer and Barry & Bonna. The only money movement allowed
// without an account is donations; event tickets keep guest checkout. This
// mirrors the authoritative server-side guard (`book_purchase_requires_account`
// in the payments handler) so the UI can redirect guests to sign in before they
// hit a 401.

/**
 * True when the cart contains a book but there is no signed-in user, i.e. the
 * purchase must be blocked / the guest must sign in first.
 *
 * @param {Array<{bookId?: number|null, eventId?: number|null}>} items
 * @param {{id?: number|null}|null|undefined} user
 * @returns {boolean}
 */
export function cartRequiresAccount (items, user) {
  const hasBooks = Array.isArray(items) && items.some(
    item => item && item.bookId !== null && item.bookId !== undefined
  )
  const signedIn = !!(user && user.id)
  return hasBooks && !signedIn
}
